import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { StateContext, states } from './form-edit-button.context';
import { DefaultFormEditButtons } from './DefaultFormEditButtons';
import { FormWarningButtons } from './FormWarningButtons';
import { FormCancelButtons } from './FormCancelButtons';
import { EditModeNavButtons } from './EditModeNavButtons';

export class FormEditButtons extends PureComponent {
  getButtons = (state) => {
    const {
      cancelHandler,
      saveEditingHandler,
      extraClassName,
      saveButtonText,
      saveButtonExtraProps,
      previousButtonHandler,
      hideSaveButton,
      hideGoBackButton,
    } = this.props;

    switch (state) {
      case states.warning:
        return (
          <FormWarningButtons
            cancelHandler={cancelHandler}
            saveEditingHandler={saveEditingHandler}
            extraClassName={extraClassName}
          />
        );
      case states.cancel:
        return (
          <FormCancelButtons
            cancelHandler={cancelHandler}
            saveEditingHandler={saveEditingHandler}
            extraClassName={extraClassName}
          />
        );
      case states.edit:
        return (
          <EditModeNavButtons
            cancelHandler={cancelHandler}
            previousButtonHandler={previousButtonHandler}
            saveEditingHandler={saveEditingHandler}
            saveButtonText={saveButtonText}
            hideGoBackButton={hideGoBackButton}
            extraClassName={extraClassName}
          />
        );
      default:
        return (
          <DefaultFormEditButtons
            cancelHandler={cancelHandler}
            saveEditingHandler={saveEditingHandler}
            extraClassName={extraClassName}
            saveButtonText={saveButtonText}
            saveButtonExtraProps={saveButtonExtraProps}
            hideSaveButton={hideSaveButton}
          />
        );
    }
  };

  render() {
    return <StateContext.Consumer>{(state) => this.getButtons(state)}</StateContext.Consumer>;
  }
}

FormEditButtons.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  saveEditingHandler: PropTypes.func,
  previousButtonHandler: PropTypes.func,
  extraClassName: PropTypes.string,
  saveButtonText: PropTypes.string,
  saveButtonExtraProps: PropTypes.shape({}),
  hideSaveButton: PropTypes.bool,
  hideGoBackButton: PropTypes.bool,
};

FormEditButtons.defaultProps = {
  saveEditingHandler: null,
  previousButtonHandler: null,
  extraClassName: '',
  saveButtonText: undefined,
  saveButtonExtraProps: {},
  hideSaveButton: false,
  hideGoBackButton: false,
};
